<h2 class="text-xl font-bold">
  Arbeit
  {{mode === 'add' ? 'hinzufügen' : 'bearbeiten'}}
</h2>
<hr />
<form class="w-full" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="flex flex-col w-full">
    <div class="flex flex-col mt-2">
      <label class="soft-label top required">Artikelnummer</label>
      @if (mode === 'edit') {
        <soft-value-converter formControlName="artikel" [converter]="artikelConverter">
          <soft-field-ok fieldOkName="artstamm"
                         [readonly]="true"
                         [parameters]="{kzartikelart: 'ARB'}">
          </soft-field-ok>
        </soft-value-converter>
      } @else {
        <soft-value-converter formControlName="artikel" [converter]="artikelConverter">
          <soft-field-ok fieldOkName="artstamm"
                         softFocus
                         [readonly]="false"
                         [parameters]="{kzartikelart: 'ARB'}">
          </soft-field-ok>
        </soft-value-converter>
      }
    </div>
  </div>
  <div class="flex flex-col mt-2">
    <label class="soft-label top required">Menge</label>
    <soft-number-input formControlName="menge"></soft-number-input>
  </div>
  <div class="flex flex-col mt-2">
    <label class="soft-label top">Aufschlag Verkauf (Prozent)</label>
    <div class="flex gap-2 w-full items-center">
      <soft-number-input formControlName="aufschlagArtikelgruppe" class="w-full"></soft-number-input>
      <span class="text-right font-semibold">%</span>
    </div>
  </div>
  <button type="submit"
          class="soft-button primary w-full h-12 mt-4"
          [disabled]="form.invalid">
    Speichern
  </button>
</form>
